if(document.querySelector('.site-header')){
  $(window).on('scroll', function() {
    // const globalHeader = $('.global-header'),
    //   siteHeader = $('.site-header'),
    //   headerHeight = globalHeader.height() + siteHeader.height(),
    //   pageY = window.pageYOffset;

    const siteHeader = $('.site-header'),
          headerHeight = siteHeader.height(),
          pageY = window.pageYOffset;

    if (pageY >= headerHeight) {
      // globalHeader.addClass("sticky");
      siteHeader.addClass("sticky");
    } else {
      // globalHeader.removeClass("sticky");
      siteHeader.removeClass("sticky");
    }
  });
}
